<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-toolbar flat dense class="custom-toolbar">
      <v-toolbar-title>Student Activity Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table :headers="headers" :items="student_activity_list" class="elevation-1 ma-5" sort-by="name"
      :search="search" hide-default-header>
      <!-- Header slot to apply background color -->
      <template v-slot:header="{ props }">
        <thead>
          <tr>
            <th v-for="header in props.headers" :key="header.value" class="custom-header">
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" style="padding: 10px" single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" small @click="openAddDialog">Add Activity Details</v-btn>
            </template>
            <v-card>
              <v-card-title class="custom-toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" v-for="field in activity_fields" :key="field.field_name"
                      v-if="field.isactive">
                      <!-- Label -->
                      <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2" style="font-size: 14px;">
                        <b>{{ field.label }}<span v-if="field.required" class="pl-1" style="color:red">*</span></b>
                      </div>

                      <!-- Text -->
                      <v-text-field v-if="field.input_type === 'text'" v-model="formData[field.field_name]"
                        :readonly="editedIndex > -1 && !field.iseditable"
                        :filled="editedIndex > -1 && !field.iseditable" dense outlined rounded
                        :placeholder="field.placeholder" :type="field.type || 'text'" />

                      <!-- Select -->
                      <v-select v-if="field.input_type === 'select'" v-model="formData[field.field_name]"
                        :items="field.options" item-text="name" item-value="id"
                        :readonly="editedIndex > -1 && !field.iseditable"
                        :filled="editedIndex > -1 && !field.iseditable" dense outlined rounded
                        :placeholder="field.placeholder" />

                      <!-- Date -->
                      <v-text-field v-if="field.input_type === 'date'" v-model="formData[field.field_name]"
                        :readonly="editedIndex > -1 && !field.iseditable"
                        :filled="editedIndex > -1 && !field.iseditable" type="date" dense outlined rounded
                        :placeholder="field.placeholder" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button" small @click="close">Cancel</v-btn>
                <v-btn class="button-77" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.level="{ item }">
        <span v-if="item.level != 'null'">{{ item.level }}</span>
        <span v-else>--</span>
      </template>
      <template v-slot:item.honours="{ item }">
        <span v-if="item.honours != 'null'">{{ item.honours }}</span>
        <span v-else>--</span>
      </template>
      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" color="green" @click="editItem(item)">edit</v-icon>
          </v-avatar>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon color="red" class="delete-v-icon mr-2" @click="deleteItem(item)">delete</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css";

  export default {
    props: {
      learner: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        overlay: false,
        dialog_upload: false,
        snackbar_msg: "",
        color: "",
        learner: "",
        snackbar: false,
        search: "",
        dialog: false,
        errorMsg: {
          activity_name: false,
        },
        headers: [
          { text: "Sr. No.", align: "left", sortable: false, value: "srno" },
          { text: "Name Of Activity", align: "left", sortable: false, value: "activity_name" },
          { text: "Role", align: "left", sortable: true, value: "role" },
          { text: "Level", align: "left", sortable: true, value: "level" },
          { text: "Honours", align: "left", sortable: true, value: "honours" },
          { text: "From Date", align: "left", value: "from_date" },
          { text: "To Date", align: "left", value: "to_date" },
          { text: "Activity Type", align: "left", value: "activity_type_name" },
          { text: "Academic Year", align: "left", value: "academicyear_name" },
          { text: "Standard", align: "left", value: "standard_name" },
          { text: "Description", align: "left", value: "description" },
          { text: "Actions", value: "action", sortable: false },
        ],
        editedIndex: -1,
        activity_type_list: [],
        student_activity_list: [],
        standard_list: [],
        award_type_list: [],
        ay_list: [],
        activity_fields: [],
        activity_name: null,
        role: null,
        level: null,
        honours: null,
        description: null,
        activity_type: null,
        academicyear: null,
        standard: null,
        awardtype: null,
        source: null,
        id: null,
        award_letter: null,
        edit_award_letter: null,
        aws_path: null,
        sizelimit: null,
        allowed_extensions: [],
        size_flag: false,
        ext_flag: false,
        menu2: false,
        menu2_edit: false,
        display_size: null,
        dateFormatted_edit: "",
        dateFormatted: "",
        to_date: new Date().toISOString().substr(0, 10),
        to_date_edit: "",
        from_date: new Date().toISOString().substr(0, 10),
        from_date_edit: "",
        formData: {}, // For dynamic fields
      };
    },
    watch: {
      learner(newVal) {
        if (newVal) {
          this.getStudentActivity();
        }
      },
      overlay(val) {
        if (val) {
          setTimeout(() => {
            this.overlay = false;
          }, 2000);
        }
      },
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "New Activity Details" : "Edit Activity Details";
      },
    },
    mounted() {
      this.learner = localStorage.getItem("learner_for_profile");
      if (this.learner) {
        this.getStudentActivity();
      }
    },
    methods: {
      getStudentActivity() {
        const formData = {
          learner: this.learner,
        };
        this.overlay = true;
        axios
          .post("/parent/getStudentActivity", formData)
          .then((res) => {
            const data = res.data;
            if (data && data.flag === "YES") {
              this.student_activity_list = data.student_activity_list || [];
              this.ay_list = data.ay_list || [];
              this.activity_type_list = data.activity_type_list || [];
              this.standard_list = data.standard_list || [];
              this.activity_fields = data.activity_fields || [];
              this.initializeFormData();
            } else {
              this.showSnackbar("#ff9800", data.message || "Unable to fetch activity data.");
            }
          })
          .catch((error) => {
            console.error("Error in getStudentActivity:", error);
            this.showSnackbar("#b71c1c", "Something went wrong while fetching activities!");
          })
          .finally(() => {
            this.overlay = false;
          });
      },
      // initializeFormData() {
      //   this.formData = {};
      //   this.activity_fields.forEach((field) => {
      //     this.$set(this.formData, field.field_name, field.value || null);
      //   });
      //   console.log("editedIndex:", this.editedIndex);
      //   console.log("activity_fields:", JSON.stringify(this.activity_fields, null, 2));
      // },
      deleteItem(item) {
        if (!confirm("Are you sure you want to delete this student activity?")) return;
        const formData = new FormData();
        formData.append("id", item.id);
        axios
          .post("/parent/deleteStudentActivity", formData)
          .then((res) => {
            if (res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Student activity deleted successfully.");
              this.student_activity_list = res.data.student_activity_list || [];
            } else if (res.data.status.code === "NOT_FOUND") {
              this.showSnackbar("#b71c1c", "Activity not found.");
            } else {
              this.showSnackbar("#b71c1c", "Failed to delete activity.");
            }
          })
          .catch((error) => {
            console.error(error);
            this.showSnackbar("#b71c1c", "Something went wrong.");
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      editItem(item) {
        if (!item || !item.activity_name) {
          this.showSnackbar("#b71c1c", "Invalid activity selected for editing.");
          return;
        }
        this.editedIndex = this.student_activity_list.indexOf(item);
        const cloned = Object.assign({}, item);

        // Populate individual variables (as requested to retain)
        this.activity_name = cloned.activity_name;
        this.role = cloned.role;
        this.id = cloned.id;
        this.level = cloned.level;
        this.honours = cloned.honours;
        this.description = cloned.description;
        this.activity_type = cloned.activity_type;
        this.academicyear = cloned.academicyear;
        this.standard = cloned.standard;
        this.from_date = this.convertDateFormat(cloned.from_date);
        this.to_date = this.convertDateFormat(cloned.to_date);

        // Populate formData for dynamic fields
        this.formData = {
          activity_name: cloned.activity_name,
          activity_role: cloned.role,
          activity_level: cloned.level,
          activity_honours: cloned.honours,
          activity_description: cloned.description,
          activity_type: cloned.activity_type,
          activity_academicyear: cloned.academicyear,
          activity_standard: cloned.standard,
          activity_from_date: this.convertDateFormat(cloned.from_date),
          activity_to_date: this.convertDateFormat(cloned.to_date),
        };

        this.dialog = true;
      },
      convertDateFormat(dateStr) {
        if (!dateStr) return null;
        const months = {
          Jan: "01",
          Feb: "02",
          Mar: "03",
          Apr: "04",
          May: "05",
          Jun: "06",
          Jul: "07",
          Aug: "08",
          Sep: "09",
          Oct: "10",
          Nov: "11",
          Dec: "12",
        };
        const parts = dateStr.split("/");
        if (parts.length === 3) {
          const day = parts[0].padStart(2, "0");
          const month = months[parts[1].substring(0, 3)];
          const year = parts[2];
          return month ? `${year}-${month}-${day}` : null;
        }
        return null;
      },
      save() {

        if (!this.isValidated()) return;
        const isEdit = this.editedIndex > -1;
        this.dialog_upload = true;
        const formData = new FormData();
        formData.append("learner", this.learner);
        formData.append("activity_name", this.formData.activity_name || this.activity_name || "");
        formData.append("role", this.formData.activity_role || this.role || "");
        formData.append("level", this.formData.activity_level || this.level || "");
        formData.append("honours", this.formData.activity_honours || this.honours || "");
        formData.append("description", this.formData.activity_description || this.description || "");
        formData.append("activity_type", this.formData.activity_type || this.activity_type || "");
        formData.append("academicyear", this.formData.activity_academicyear || this.academicyear || "");
        formData.append("standard", this.formData.activity_standard || this.standard || "");
        formData.append("from_date", this.formData.activity_from_date || this.from_date || "");
        formData.append("to_date", this.formData.activity_to_date || this.to_date || "");
        if (isEdit && this.id) {
          formData.append("id", this.id);
        }
        axios
          .post("/parent/saveStudentActivity", formData)
          .then((res) => {
            if (res.data.status.code === "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                isEdit ? "Student Activity details updated successfully..." : "Student Activity details added successfully..."
              );
              this.student_activity_list = res.data.student_activity_list || [];
            } else if (res.data.status.code === "NA") {
              this.showSnackbar(
                "#b71c1c",
                isEdit ? "Student Activity already exists with these details!!!" : "Student Activity already present!!!"
              );
            } else if (res.data.status.code === "NOT_FOUND") {
              this.showSnackbar("#b71c1c", "Activity not found for update!");
            } else {
              this.showSnackbar("#b71c1c", "Unexpected server response.");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            console.error(error);
          })
          .finally(() => {
            this.resetForm();
            this.dialog_upload = false;
            this.close();
          });
      },
      initializeFormData() {
        this.formData = {};
        this.activity_fields.forEach((field) => {
          // Set null in Add mode (editedIndex === -1), use field.value in Edit mode
          this.$set(this.formData, field.field_name, this.editedIndex === -1 ? null : field.value || null);
        });
        console.log("initializeFormData - editedIndex:", this.editedIndex, "formData:", this.formData);
      },

      openAddDialog() {
        this.resetForm(); // Ensure form is reset before opening Add dialog
        this.editedIndex = -1;
        this.dialog = true;
      },

      resetForm() {
        // Reset individual variables
        this.activity_name = null;
        this.role = null;
        this.level = null;
        this.honours = null;
        this.activity_type = null;
        this.academicyear = null;
        this.standard = null;
        this.from_date = "";
        this.to_date = "";
        this.description = null;
        this.id = null;
        this.award_letter = null;
        this.edit_award_letter = null;
        this.awardtype = null;
        this.source = null;
        this.dateFormatted = "";
        this.editedIndex = -1;

        // Reset formData for dynamic fields
        this.formData = {};
        this.activity_fields.forEach((field) => {
          this.$set(this.formData, field.field_name, null);
        });
        console.log("resetForm - formData:", this.formData);
      },
      isValidated() {
      for (const field of this.activity_fields) {
        if (field && field.isactive && field.required) {
          let val = this.formData[field.field_name];
          // Map field_name to individual variables for compatibility
          switch (field.field_name) {
            case 'activity_name':
              val = this.formData.activity_name || this.activity_name;
              break;
            case 'activity_role':
              val = this.formData.activity_role || this.role;
              break;
            case 'activity_level':
              val = this.formData.activity_level || this.level;
              break;
            case 'activity_honours':
              val = this.formData.activity_honours || this.honours;
              break;
            case 'activity_type':
              val = this.formData.activity_type || this.activity_type;
              break;
            case 'activity_academicyear':
              val = this.formData.activity_academicyear || this.academicyear;
              break;
            case 'activity_standard':
              val = this.formData.activity_standard || this.standard;
              break;
            case 'activity_from_date':
              val = this.formData.activity_from_date || this.from_date;
              break;
            case 'activity_to_date':
              val = this.formData.activity_to_date || this.to_date;
              break;
            case 'activity_description':
              val = this.formData.activity_description || this.description;
              break;
          }

          if (field.input_type === 'select' || field.input_type === 'date') {
            if (!val) {
              this.showSnackbar("#b71c1c", `Please ${field.input_type === 'select' ? 'Select' : 'Enter'} ${field.label}!!!`);
              return false;
            }
          } else {
            const trimmedVal = val !== null && val !== undefined ? String(val).trim() : '';
            if (trimmedVal === '') {
              this.showSnackbar("#b71c1c", `Please Enter ${field.label}!!!`);
              return false;
            }
          }
        }
      }

      // Check description length if provided and required
      const descriptionField = this.activity_fields.find(field => field.field_name === 'activity_description');
      if (descriptionField && descriptionField.required && 
          (this.formData.activity_description || this.description) && 
          (this.formData.activity_description || this.description).length > 250) {
        this.showSnackbar("#b71c1c", "Please enter description in 250 characters!!!");
        return false;
      }

      return true;
    },

  
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },
      parseDate(date) {
        if (!date) return null;
        const [month, day, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
      close() {
        this.dialog = false;
        this.resetForm();
      },
    },
  };
</script>
<style scoped>
  .slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
    font-size: 80%;
  }

  .mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
        #2c5364,
        #203a43,
        #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
        #2c5364,
        #203a43,
        #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
  }

  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }

  .custom-header {
    background: linear-gradient(to right, #ffe0b2, #ffccbc);

    color: black !important;
    /* Optional: makes text readable */
    font-weight: bold;
  }

  .button-77 {
    /* background-color: initial; */
    /* border-style: none; */
    color: #fff;
    cursor: pointer;
    /* font-size: 16px; */
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
    /* padding: 19px 16px; */
  }

  /* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, 0.32);
    content: "";
  }

  .button-77:after {
    /* background-color: initial; */
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0.2)),
      linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: 0.24;
  }
</style>